import React, { Component, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import Footer from "./Footer";
import "../../assets/scss/app.scss";
import { scAxiosAdmin, thirdparty } from "../..";
import { API_TOKEN_NAME } from "../../constants";
import { ToastContainer, toast } from "react-toastify";

const adminRolePermission = (props) => {
  // console.log("role_id", props.match.params.id);
  const [fatchData, setFatchdata] = useState({
    role_name: "",
    permission: [],
    status: 1,
  });
  const [loading, setLoading] = useState(true);
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFatchdata({
      ...fatchData,
      [name]: value,
    });
  };

  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    let permission_list = fatchData.permission;
    console.log(id, checked);
    if (checked) {
      // If the checkbox is checked (true), add the id to the state array
      permission_list.push(id);
    } else {
      // If the checkbox is unchecked (false), remove the id from the state array
      permission_list = permission_list.filter((item) => item !== id);
    }

    setFatchdata((prev) => ({
      ...prev,
      permission: permission_list,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    try {
      const response = await scAxiosAdmin.put(
        `/roles/${props.match.params.id}`,
        fatchData,
        {
          method: "put",
          headers: {
            Accept: "application/json",
            "Content-Type": `application/json`,
            Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
          },
        }
      );

      if (response.status === 200) {
        toast.success("Permission updated successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
      }
    } catch (err) {
      setError(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const response = await thirdparty.get(`/roles/${props.match.params.id}`);
      if (response.status == 200) {
        setFatchdata(...fetchData, {
          role_name: response.data.role_name,
          permission: response.data.permission || [],
          status: response.data.status,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchPermission = async () => {
    try {
      const response = await scAxiosAdmin.request(
        "/role-permission/get-permission-data",
        {
          method: "get",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
          },
          params: {
            // ...data
          },
        }
      );
      setResponseData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchPermission();
  }, []);

  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper pl-4 pl-4">
              {responseData && (
                <form noValidate onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-12 mb-4  d-flex justify-content-between align-items-center">
                      <h5>Role-Permission Setting</h5>
                      <a
                        href="/admin/role-manager"
                        className="btn btn-sm waves-effect waves-light"
                      >
                        User Roles
                      </a>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Role Title</label>
                            <input
                              type="text"
                              id="role_name"
                              name="role_name"
                              value={fatchData.role_name}
                              onChange={handleChange}
                              className="form-control"
                              placeholder="Serial Number"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Status</label>
                            <select
                              className="form-control"
                              name="status"
                              id="author_id"
                              value={fatchData.status}
                              onChange={handleChange}
                            >
                              <option value="1" key="1">
                                Active
                              </option>
                              <option value="0" key="0">
                                Inactive
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className=" row row-cols-1 row-cols-md-2 row-cols-lg-3">
                        {Object.entries(responseData).map(
                          ([groupName, groupPermissions]) => (
                            <div key={groupName}>
                              <h3>{groupName}</h3>
                              <div className="form-group">
                                {groupPermissions.map((permission) => (
                                  <div
                                    className="form-check"
                                    key={permission.id}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`${permission.slug}`}
                                      checked={
                                        (fatchData.permission &&
                                          fatchData.permission.includes(
                                            `${permission.slug}`
                                          )) ||
                                        false
                                      }
                                      onChange={handleCheckboxChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`${permission.slug}`}
                                    >
                                      {permission.permission_name}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )
                        )}
                      </div>
                      <div className="row">
                        <div className="col-md-12 text-right">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
          <Route component={Footer} />
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default adminRolePermission;



// WEBPACK FOOTER //
// ./src/component/admin/adminRolePermission.js